import React from "react"
import { formatNumber } from "@ncs/ts-utils"
import { BoxProps } from "../layout"
import { Paragraph } from "../typography"
import { Skeleton } from "@material-ui/lab"

export interface ResultCountSummaryEcommProps extends BoxProps {
	currentTotal: number
	totalResults: number | null
	resultWord?: string
	searchItem?: string | null
}

export const ResultCountSummaryEcomm: React.FC<ResultCountSummaryEcommProps> = ({
	currentTotal,
	totalResults,
	resultWord = "result",
	searchItem,
}) => {
	return (
		<>
			{totalResults === null ?
				<Skeleton />
			:	<>
					{searchItem ?
						<Paragraph fontSize={1.5} customColor="#374151">
							Results for {'"'}
							{searchItem && <strong>{searchItem}</strong>}
							{'"'}
						</Paragraph>
					:	<Paragraph bold fontSize={1.5} customColor="#374151">
							Search Results
						</Paragraph>
					}
					<Paragraph css={{ marginTop: "0.25rem" }}>
						Showing {formatNumber(currentTotal)} of {formatNumber(totalResults)}{" "}
						{resultWord}
						{totalResults !== 1 ? "s" : ""}
					</Paragraph>
				</>
			}
		</>
	)
}
